import { Select, TextField } from "@mui/material";
import { styled } from "styled-components";
import { palette, shape } from "./constants";

export const FormWrapper = styled.div`
  position: relative;
  flex-grow: 1;
  height: calc(100vh - 57px);
  overflow: auto;
  padding: 48px 0 0 80px;
`;

export const BorderForm = styled.div`
  border: ${palette.border.grey};
  border-radius: ${shape.rounding.XL};
  padding: 24px;
  max-width: 744px;
  flex-grow: 1;
`;

export const StyledTextField = styled(TextField)`
  width: 100%;

  box-sizing: border-box;
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
    -webkit-text-fill-color: black;
    box-shadow: 0 0 0 30px white inset !important;
  }
  & .MuiOutlinedInput-root.Mui-focused fieldset {
    border: 2px solid ${palette.colors.green_base};
    color: ${palette.colors.green_base};
  }
  & .MuiFormHelperText-root {
    margin-left: 0;
  }
  & .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline,
  .MuiOutlinedInput-root.Mui-error fieldset {
    color: ${palette.colors.error};
    border-color: ${palette.colors.error};
  }
  & .MuiFormHelperText-root.Mui-error {
    color: ${palette.colors.error};
  }
  & .MuiOutlinedInput-root.Mui-focused fieldset legend span {
    color: ${palette.colors.green_base};
  }
`;

export const CheckBoxContainer = styled.div`
  width: 100%;

  & .MuiFormControlLabel-root {
    margin-left: 0;
  }
  & .MuiCheckbox-colorPrimary.Mui-checked {
    color: ${palette.colors.green_base};
  }
  & .MuiButtonBase-root-MuiCheckbox-root:hover {
    background: none;
  }
  & span {
    padding: 0;
    margin-right: 4px;
  }
`;

export const StyledSelect = styled(Select)`
  &.MuiOutlinedInput-root {
    color: ${palette.colors.onsurface};

    & .MuiOutlinedInput-notchedOutline {
      border-color: ${palette.colors.green_base} !important;
    }
    & legend {
      & > span {
        display: none;
      }
    }
  }
`;

export const ContainerSpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
`;

export const SocialAuthGroup = styled.div`
  flex-grow: 1;
  max-width: 323px;
`;

export const SocialAuthTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SocialAuthTitleText = styled.div`
  font-size: 16px;
  line-height: 1.5;
  font-weight: 500;
  margin-bottom: 16px;
`;

export const Line = styled.div`
  height: 1px;
  width: 100%;
  background-color: #C2C9BD;
  flex-grow: 1;
`;

export const SocialButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SocialButton = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 100px;
  font-size: 14px;
  line-height: 1.42;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;

  & svg {
    margin-right: 8px;
  }
`;

export const VkButton = styled(SocialButton)`
  background-color: #0077FF;

  &:hover {
    background-color: #3392FF;
  }
`;

export const YandexButton = styled(SocialButton)`
  background-color: #000;

  &:hover {
    background-color: #333333;
  }
`;

export const GoogleButton = styled(SocialButton)`
  background-color: #D95040;

  &:hover {
    background-color: #E17366;
  }
`;

